import classNames from 'classnames';
import {CSSProperties, ReactNode} from 'react';

export type BalloonBoxProps = {
  className?: string;
  children: ReactNode;
  style?: CSSProperties;
};

const BalloonBox = (props: BalloonBoxProps) => {
  const {className, style, children} = props;

  return (
    <div
      className={classNames(
        'relative flex rounded-2xl min-w-[3rem] border-normal border-primary-500 bg-primary-100 justify-center items-center after:absolute after:top-[1px] after:w-14 after:h-14 after:-mt-8 after:-rotate-45 after:bg-primary-100 after:border-primary-500 after:border-t-normal after:border-l-0 after:border-r-normal after:border-b-0',
        className
      )}
      style={style}
    >
      <div className="p-10 font-sans font-semibold text-2xl text-primary-800 mobile:text-lg">{children}</div>
    </div>
  );
};

export default BalloonBox;
